export default __webpack_public_path__ + "static/media/plan-advanced.894bec71.svg";